import type { SVGProps } from 'react';

export const LoadingIllustration = (
  props: SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    width="134"
    height="103"
    viewBox="0 0 134 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_559_38077)">
      <path
        d="M60.04 80.545c-18.426-7.633-27.176-28.757-19.544-47.183C48.13 14.937 69.253 6.187 87.68 13.82s27.175 28.757 19.543 47.183S78.465 88.177 60.04 80.545"
        fill="#1d2124"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m42.796 83.14-7.442 7.812a3.48 3.48 0 0 1-4.919 0 3.48 3.48 0 0 1 0-4.92l8.139-7.747 24.388-23.233 1.689 1.689 1.689 1.689z"
        fill="#1d2124"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m64.969 54.789-23.54 24.71-7.44 7.811a3.48 3.48 0 0 1-4.92 0 3.48 3.48 0 0 1 0-4.919l8.139-7.747 24.388-23.228"
        fill="#a456f6"
      />
      <path
        d="m64.969 54.789-23.54 24.71-7.44 7.811a3.48 3.48 0 0 1-4.92 0 3.48 3.48 0 0 1 0-4.919l8.139-7.747 24.388-23.228"
        stroke="#1d2124"
        strokeMiterlimit="10"
      />
      <path
        d="M72.98 79.869c-19.943 0-36.11-16.167-36.11-36.11 0-19.944 16.167-36.111 36.11-36.111 19.944 0 36.111 16.167 36.111 36.11 0 19.944-16.167 36.11-36.11 36.11Z"
        fill="#a456f6"
        stroke="#1d2124"
        strokeMiterlimit="10"
      />
      <path
        d="M72.98 75.372c-17.459 0-31.613-14.154-31.613-31.614s14.154-31.614 31.614-31.614 31.614 14.154 31.614 31.614-14.154 31.614-31.614 31.614Z"
        fill="#fff"
        stroke="#1d2124"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.052 32.226c-10.846 0-20.562 4.803-27.16 12.392 6.598 7.585 16.314 12.393 27.16 12.393s20.562-4.803 27.159-12.393c-6.602-7.589-16.318-12.392-27.159-12.392Z"
        fill="#fff"
        stroke="#1d2124"
        strokeMiterlimit="10"
      />
      <path
        id="pupil"
        d="M85.332 53.269a8.656 8.656 0 1 0 0-17.312 8.656 8.656 0 0 0 0 17.312"
        fill="#1d2124"
      >
        <animate
          attributeName="d"
          values="M85.3323 53.2687C90.1126 53.2687 93.9879 49.3935 93.9879 44.6131C93.9879 39.8328 90.1126 35.9576 85.3323 35.9576C80.552 35.9576 76.6768 39.8328 76.6768 44.6131C76.6768 49.3935 80.552 53.2687 85.3323 53.2687Z;M85.3323 53.2687C90.1126 53.2687 93.9879 49.3935 93.9879 44.6131C93.9879 39.8328 90.1126 35.9576 85.3323 35.9576C80.552 35.9576 76.6768 39.8328 76.6768 44.6131C76.6768 49.3935 80.552 53.2687 85.3323 53.2687Z;M63.3313 53.2686C68.1117 53.2686 71.9869 49.3934 71.9869 44.6131C71.9869 39.8327 68.1117 35.9575 63.3313 35.9575C58.551 35.9575 54.6758 39.8327 54.6758 44.6131C54.6758 49.3934 58.551 53.2686 63.3313 53.2686Z;M63.3313 53.2686C68.1117 53.2686 71.9869 49.3934 71.9869 44.6131C71.9869 39.8327 68.1117 35.9575 63.3313 35.9575C58.551 35.9575 54.6758 39.8327 54.6758 44.6131C54.6758 49.3934 58.551 53.2686 63.3313 53.2686Z;M85.3323 53.2687C90.1126 53.2687 93.9879 49.3935 93.9879 44.6131C93.9879 39.8328 90.1126 35.9576 85.3323 35.9576C80.552 35.9576 76.6768 39.8328 76.6768 44.6131C76.6768 49.3935 80.552 53.2687 85.3323 53.2687Z;"
          dur="3s"
          repeatCount="indefinite"
          calcMode="spline"
          keyTimes="0;0.4;0.5;0.9;1"
          keySplines="0 0 1 1;0.75 0 1 1;0 0 1 1;0.75 0 1 1;"
        />
      </path>
      <path
        d="M74.052 32.226v-9.31M61.824 34.195l-3.605-8.587m27.607 8.587 3.6-8.587"
        stroke="#1d2124"
        strokeMiterlimit="10"
      />
    </g>
    <path
      className="sparkle"
      id="sparkle01"
      d="m11.676 6 1.473 4.69a5.2 5.2 0 0 0 3.854 3.856L21.676 16l-4.691 1.473a5.2 5.2 0 0 0-3.855 3.854L11.676 26l-1.473-4.69a5.2 5.2 0 0 0-3.854-3.855L1.676 16l4.69-1.473a5.2 5.2 0 0 0 3.855-3.854z"
      stroke="#1d2124"
      strokeWidth="1"
      fill="url(#softGlow)"
    />
    <path
      className="sparkle"
      id="sparkle02"
      d="m129.176 8 .663 2.11a2.34 2.34 0 0 0 1.734 1.736l2.103.654-2.111.663a2.34 2.34 0 0 0-1.735 1.734L129.176 17l-.663-2.11a2.34 2.34 0 0 0-1.734-1.735l-2.103-.655 2.111-.663a2.34 2.34 0 0 0 1.734-1.734z"
      stroke="var(--xdlColorText)"
      fill="#1d2124"
    />
    <path
      className="sparkle"
      id="sparkle03"
      d="m121.676 85 1.178 3.753a4.16 4.16 0 0 0 3.084 3.083L129.676 93l-3.753 1.178a4.16 4.16 0 0 0-3.084 3.084L121.676 101l-1.178-3.753a4.16 4.16 0 0 0-3.084-3.083L113.676 93l3.753-1.178a4.16 4.16 0 0 0 3.083-3.084z"
      stroke="#1d2124"
      strokeWidth="1"
      fill="url(#softGlow)"
    />
    <path
      className="sparkle"
      id="sparkle04"
      d="m37.5 2 .81 2.58a2.86 2.86 0 0 0 2.12 2.12l2.57.8-2.58.81a2.86 2.86 0 0 0-2.12 2.12L37.5 13l-.81-2.58a2.86 2.86 0 0 0-2.12-2.12L32 7.5l2.58-.81a2.86 2.86 0 0 0 2.12-2.12z"
      stroke="var(--xdlColorText)"
      fill="#1d2124"
    />
    <path
      className="sparkle"
      id="sparkle05"
      d="m9.5 86 .663 2.11a2.34 2.34 0 0 0 1.734 1.736L14 90.5l-2.11.663a2.34 2.34 0 0 0-1.735 1.734L9.5 95l-.663-2.11a2.34 2.34 0 0 0-1.734-1.736L5 90.5l2.11-.663a2.34 2.34 0 0 0 1.735-1.734z"
      stroke="var(--xdlColorText)"
      fill="#1d2124"
    />
    <path
      className="sparkle"
      id="sparkle06"
      d="m22 54 .884 2.815a3.12 3.12 0 0 0 2.312 2.312L28 60l-2.814.884a3.12 3.12 0 0 0-2.313 2.312L22 66l-.884-2.815a3.12 3.12 0 0 0-2.312-2.312L16 60l2.814-.884a3.12 3.12 0 0 0 2.313-2.312z"
      stroke="#1d2124"
      strokeWidth="1"
      fill="url(#softGlow)"
    />
    <path
      className="sparkle"
      id="sparkle07"
      d="m122 54 1.031 3.284a3.64 3.64 0 0 0 2.698 2.698L129 61l-3.284 1.03a3.64 3.64 0 0 0-2.698 2.7L122 68l-1.031-3.284a3.64 3.64 0 0 0-2.698-2.698L115 61l3.284-1.03a3.64 3.64 0 0 0 2.698-2.7z"
      stroke="#1d2124"
      strokeWidth="1"
      fill="url(#softGlow)"
    />
    <defs>
      <radialGradient id="softGlow" cx="80%" cy="40%" r="70%">
        <stop offset="0%" stopColor="#fe9a95" />
        <stop offset="70%" stopColor="#bd85fb" />
        <stop offset="100%" stopColor="#8a2ce8" />
      </radialGradient>
      <clipPath id="clip0_559_38077">
        <path fill="#fff" d="M25.676 0h95v95h-95z" />
      </clipPath>
    </defs>
  </svg>
);
